import { render, staticRenderFns } from "./NACEChooseBox.vue?vue&type=template&id=65081aa6&scoped=true&"
import script from "./NACEChooseBox.vue?vue&type=script&lang=js&"
export * from "./NACEChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./NACEChooseBox.vue?vue&type=style&index=0&id=65081aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65081aa6",
  null
  
)

export default component.exports